const events = Object.freeze({
  start: { id: 22 },
  end: { id: 23 },
  display: { id: 30 },
  touch: { id: 31 },
  action: { id: 32 },
  play: { id: 33 },
  pause: { id: 34 },
  hide: { id: 35 },
  scrub: { id: 36 },
  interactiveDisplay: { id: 41 },
  interactiveTouch: { id: 42 },
  interactiveClose: { id: 43 },
  autoHide: { id: 44 },
  mute: { id: 45 },
  unmute: { id: 46 },
  videoClickOut: { id: 47 },
  clickOut: { id: 48 },
  socialLinkShare: { id: 49 },
  socialShare: { id: 50 },
  "ad:failure": { id: 51 },
  "ad:render": { id: 52 }
});
const getEventId = (eventName) => {
  var _a;
  return ((_a = events[eventName]) == null ? void 0 : _a.id) ?? null;
};
const isSupportedEvent = (eventName) => getEventId(eventName) != null;
export {
  events as EventMap,
  getEventId,
  isSupportedEvent
};
